<template>
  <!-- Home Page -->
  <div>
    <div class="mb-8 lg:mb-0">
      <Header />
    </div>
    <!-- <div class="mb-8 lg:mb-0"> -->
    <!-- <ClientLogos /> -->
    <!-- </div> -->
    <div class="mb-8 lg:mb-0">
      <Features />
    </div>
    <div class="mb-8 lg:mb-0">
      <Benefits />
    </div>
    <!-- <Do /> -->
    <div class="mb-8 lg:mb-0">
      <Process />
    </div>
    <div class="mb-8 lg:mb-0">
      <CTA />
    </div>

    <div class="mb-8 lg:mb-0">
      <HomeSignup />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/sections/HomeHeader.vue";
// import ClientLogos from "@/components/sections/HomeClientLogos.vue";
import Features from "@/components/sections/HomeFeatures.vue";
import Benefits from "@/components/sections/HomeBenefits.vue";
// import Do from "@/components/sections/HomeDo.vue";
import Process from "@/components/sections/HomeProcess.vue";
import Footer from "@/components/sections/HomeFooter.vue";
import CTA from "@/components/sections/HomeCTA.vue";
import HomeSignup from "@/components/sections/HomeSignup.vue";

// extra

export default {
  name: "HomePage",
  components: {
    Header,
    // ClientLogos,
    Features,
    Benefits,
    // Do,
    Process,
    CTA,
    Footer,
    HomeSignup,
  },
};
</script>
